import { ReactElement, MouseEvent, useCallback } from 'react';
import { Avatar, Typography, Stack, IconButton } from '@mui/material';
import {
  Email as EmailIcon,
  WhatsApp as WhatsAppIcon,
} from '@mui/icons-material';

import { getInitialsNameLetterUpperCase } from '~utils/user';
import { openUrlInNewTab } from '~utils/commons';

import { DashboardVariantV2GiverInfoCurrentCarrierCompanyProps } from './types';
import { DashboardVariantV2GiverInfoCurrentCarrierCompanyContainer } from './styles';

const DashboardVariantV2GiverInfoCurrentCarrierCompany = ({
  name,
  email,
  logoUrl,
  numberPhone,
}: DashboardVariantV2GiverInfoCurrentCarrierCompanyProps): ReactElement => {
  const handleOpenInNewTab = useCallback(
    (url: string) => (event: MouseEvent<HTMLElement>) => {
      event.stopPropagation();

      openUrlInNewTab(url);
    },
    [],
  );

  return (
    <DashboardVariantV2GiverInfoCurrentCarrierCompanyContainer>
      <Avatar alt={name} src={logoUrl} sx={{ width: 35, height: 35 }}>
        {getInitialsNameLetterUpperCase(name)}
      </Avatar>

      <Stack>
        <Typography variant="body2" color="text.primary" fontWeight="bold">
          {name}
        </Typography>

        <Typography variant="caption" color="primary.main" fontWeight="medium">
          Transportista asociado
        </Typography>
      </Stack>

      <Stack direction="row" spacing={0.5}>
        <IconButton
          onClick={handleOpenInNewTab(`mailto:${email}`)}
          color="default"
          size="small"
        >
          <EmailIcon />
        </IconButton>

        {numberPhone && (
          <IconButton
            onClick={handleOpenInNewTab(`https://wa.me/${numberPhone}`)}
            color="success"
            size="small"
          >
            <WhatsAppIcon />
          </IconButton>
        )}
      </Stack>
    </DashboardVariantV2GiverInfoCurrentCarrierCompanyContainer>
  );
};

export default DashboardVariantV2GiverInfoCurrentCarrierCompany;
